import { DeleteFilled, ExclamationCircleFilled } from "@ant-design/icons";
import { Button, message, Modal, Tooltip } from "antd";
import React, { useState } from "react";
import { DelCustomerAccount } from "../../API/DeleteData";

const DeleteAccount = ({ onData, onDelete }) => {

  const { AccountId, CustomerId } = onData;

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const res = await DelCustomerAccount(
        AccountId,
        CustomerId
      );
      if (res.status === 200) {
        message.success(res.data.message);
        onDelete(true);
        Modal.destroyAll();
        setIsModalOpen(false);
      }
    } catch (error) {
      console.log(error);
      message.error(error.response.data.message);
    }
    setIsLoading(false);
  };

  return (

    <div className="text-primary hover:text-primary-600 font-medium">
      <Tooltip title="Delete">
        <Button icon={<DeleteFilled />} onClick={showModal} type="text" />
      </Tooltip>
      {/* Modal Confirmation Saving Data */}
      <Modal
        centered
        open={isModalOpen}
        closable={false}
        footer={
          <div className="flex gap-2 justify-end">
            <Button type="primary" loading={isLoading} onClick={handleDelete}>Submit</Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <ExclamationCircleFilled className="text-2xl text-primary" />
            <h1 className="font-bold text-lg">Are you sure Deleted this data?</h1>
          </div>
          <p>Data for Sales Name <span className="font-medium">"{onData.CustomerName}"</span></p>
        </div>
      </Modal>

    </div>

  );
};

export default DeleteAccount;
